
import {useConfig,useDealerInfo,useLogger, useAssociatedDealers, useDealerSwitch, useDealerMask} from '@gplibraries/react/hooks';
import {ErrorBoundary,PageTitle,Breadcrumbs, Icon} from '@gplibraries/react/components';
import {useNavigate } from 'react-router';
import { useEffect} from "react";

const WrongDivisionContent = () => {
  const env = useConfig("environment");
  const isProd = env === "production";

  const otherDivisionUrl = isProd ? "https://dealers.landpride.com" : "https://dev-dealers.landpride.net";
  const { data: dealerInfo, loading: dealerInfoLoading } = useDealerInfo();
  const navigate = useNavigate();
  const switchDealer = useDealerSwitch();
  const { data: associatedDealers } = useAssociatedDealers();
  const { data: mask, loading: maskLoading } = useDealerMask();

  const loading = dealerInfoLoading || maskLoading;

  const divisions = Array.isArray(dealerInfo?.divisions)
    ? dealerInfo.divisions
    : [];

  const hasDivision01 = divisions.some((d) =>
    String(d)?.includes('01')
  );

  useEffect(() => {
      // If the current mask/dealer is a GP dealer OR the user is not currently
      // masked, they should not be on this page.
      if (!loading && (hasDivision01 || mask === false)) {
        navigate('/');
      }
    }, [loading, hasDivision01, navigate]);


  if (loading) return null;

  return (
    <>
      {hasDivision01 && <Breadcrumbs />}

      <PageTitle>Access Restricted</PageTitle>

      <p>This dealer is not allowed to access Great Plains Dealer Access.</p>
      {associatedDealers.length > 0 && <p> Please switch to a valid Great Plains dealer or go to Land Pride Dealer Access.</p>}

      {associatedDealers.length > 0 &&
        <button className={'text-only bold primary'} onClick={switchDealer}>
          <Icon glyph={'arrow-repeat'}/> Switch Dealer
        </button>
      }
<br/>
      <a
        href={otherDivisionUrl}
        rel="noopener noreferrer"
      >
       <Icon glyph={'chevron-left'}/> Go to Land Pride Dealer Access
      </a>
    </>
  );
};

const WrongDivision = () => {
  const logger = useLogger();

  return (
    <ErrorBoundary logger={logger}>

        <WrongDivisionContent />

    </ErrorBoundary>
  );
};

export default WrongDivision;
